/* ═══ EUROLATINA COR PICKER v5 ═══ */
(function() {
  'use strict';

  var RAL_CATS = [
    { prefix: '1', label: 'Amarelos', cor: '#E5BE01' },
    { prefix: '2', label: 'Laranjas', cor: '#ED760E' },
    { prefix: '3', label: 'Vermelhos', cor: '#CC0605' },
    { prefix: '4', label: 'Violetas', cor: '#924E7D' },
    { prefix: '5', label: 'Azuis', cor: '#2271B3' },
    { prefix: '6', label: 'Verdes', cor: '#317F43' },
    { prefix: '7', label: 'Cinzas', cor: '#909090' },
    { prefix: '8', label: 'Marrons', cor: '#6C3B2A' },
    { prefix: '9', label: 'Preto/Branco', cor: '#1C1C1C' }
  ];

  var RAL_HEX = {
    '1000': '#F0F0E8', '1001': '#F8D4A8', '1002': '#E8C86D', '1003': '#EDBE13', '1004': '#DFC343',
    '1005': '#C9B84D', '1006': '#E3BC71', '1007': '#8F7D36', '1011': '#A39B89', '1012': '#C8A882',
    '1013': '#EDD5B1', '1014': '#E5D4B8', '1015': '#F5EDD8', '1016': '#FFF8DC', '1017': '#F5D033',
    '1018': '#F8F32D', '1019': '#9B8F36', '1020': '#9D8B3F', '1021': '#F3DA0B', '1023': '#F0B000',
    '1024': '#ABA000', '1027': '#9D8E00', '1028': '#8B7D1B', '1032': '#D4AF37', '1033': '#A39A73',
    '1034': '#A39365', '1035': '#6B5D3F', '1036': '#4B3C28', '1037': '#7A6B47',
    '2000': '#E8662D', '2001': '#D0652B', '2002': '#D35C2B', '2003': '#F2740F', '2004': '#DD7F38',
    '2008': '#C75E26', '2009': '#BB5C3D', '2010': '#D96500', '2011': '#D36E20', '2012': '#DD6F3C', '2013': '#C35831',
    '3000': '#AC2E2E', '3001': '#A00E2E', '3002': '#A03043', '3003': '#8F1530', '3004': '#6F3C3B',
    '3005': '#6F1D3B', '3007': '#51263C', '3009': '#6F2D3F', '3011': '#6F1D47', '3012': '#D4696B',
    '3013': '#A65E56', '3014': '#B0695F', '3015': '#D4808D', '3016': '#7F3B35', '3017': '#7F5C4F',
    '3018': '#CC0605', '3020': '#CC0605', '3022': '#5F3C3F', '3027': '#62443C', '3028': '#CB3234',
    '3031': '#6B443C', '3032': '#5A433C', '3033': '#5F433C',
    '4001': '#8D7BA8', '4002': '#974E6D', '4003': '#9E8FA8', '4004': '#5F3C56', '4005': '#6E5C8F',
    '4006': '#8F3C6B', '4007': '#4B3C5C', '4008': '#804D73', '4009': '#8B7B8F', '4010': '#6E6B80',
    '4011': '#8D7B9D', '4012': '#6B5F7D',
    '5000': '#246B8B', '5001': '#0A4B70', '5002': '#00366B', '5003': '#1A3C56', '5004': '#1A2638',
    '5005': '#004B87', '5007': '#3F5F8F', '5008': '#2E3C52', '5009': '#2E4052', '5010': '#0A4B73',
    '5011': '#0A2D52', '5012': '#3F7BA8', '5013': '#1A4D87', '5014': '#6B8BA8', '5015': '#417BA8',
    '5017': '#0A4D8F', '5018': '#1A7F87', '5019': '#1A6B7F', '5020': '#1A5F73', '5021': '#0A735C',
    '5022': '#354556', '5023': '#5F8F9D', '5024': '#5F9BA8', '5025': '#2A6478', '5026': '#102C54',
    '6000': '#2D6B4F', '6001': '#1F6B4F', '6002': '#3C5242', '6003': '#4B6B56', '6004': '#1A3C2E',
    '6005': '#004B30', '6006': '#3C5C47', '6007': '#2E4938', '6008': '#39433C', '6009': '#233C28',
    '6010': '#4B7356', '6011': '#5F7B65', '6012': '#3C4F42', '6013': '#7F9B82', '6014': '#47524A',
    '6015': '#3C4A3F', '6016': '#0A5C3F', '6017': '#5C8F56', '6018': '#87B738', '6019': '#85B82E',
    '6020': '#3C5C2E', '6021': '#87B738', '6022': '#3C473C', '6024': '#2E735C', '6025': '#57753C',
    '6026': '#004B3C', '6027': '#84B82E', '6028': '#4B6B38', '6029': '#2D5242', '6032': '#5F8F7F',
    '6033': '#7F9B8F', '6034': '#7F9B99', '6035': '#6B8F82', '6036': '#5F7B73', '6037': '#6B8F82',
    '7000': '#787878', '7001': '#8F8F8F', '7002': '#8F8B7F', '7003': '#7F8B7B', '7004': '#969B99',
    '7005': '#6B7570', '7006': '#6B6B5F', '7008': '#706B5F', '7009': '#626B5F', '7010': '#6B7B73',
    '7011': '#56605C', '7012': '#4F6165', '7013': '#56605F', '7015': '#414A4D', '7016': '#3C4A4F',
    '7021': '#3C4347', '7022': '#3C3C3C', '7023': '#6B7B7B', '7024': '#3F5F73', '7026': '#36505F',
    '7030': '#7F8B7F', '7031': '#47565C', '7032': '#7F8B8F', '7033': '#7B8F8F', '7034': '#8F9B99',
    '7035': '#99ABAD', '7036': '#5F6B73', '7037': '#7F8B8F', '7038': '#B3BCC4', '7039': '#6B737B',
    '7040': '#9BA8B5', '7042': '#6F7B8F', '7043': '#4F5F6F', '7044': '#B3BCC4', '7045': '#909BA3',
    '7046': '#82909B', '7047': '#D0D5DB', '7048': '#7F8B99',
    '8001': '#8B5C3C', '8002': '#6F4C2D', '8003': '#6B4D2E', '8004': '#8B4C2D', '8007': '#56433C',
    '8008': '#6B5242', '8011': '#5F4A42', '8012': '#5F3C3F', '8014': '#6B5C56', '8015': '#593C3F',
    '8016': '#4B3C3F', '8017': '#3C3C3C', '8019': '#3C3C3C', '8022': '#2E2E2E', '8023': '#6B4C42',
    '8024': '#7F6B5C', '8025': '#7F7B73', '8028': '#4B4342', '8029': '#7F6B5C',
    '9001': '#E5E1DB', '9002': '#E5E5E5', '9003': '#FFFFFF', '9004': '#1C1C1C', '9005': '#0F0F0F',
    '9006': '#A8ACAD', '9007': '#80888B', '9010': '#D0D0D0', '9011': '#1A1A1A', '9016': '#F5F5F5',
    '9017': '#1C1C1C', '9018': '#D5D5D5', '9022': '#5F6B73', '9023': '#707880'
  };

  var RAL_NAMES = {
    '1000': 'Greige / Bege acinzentado', '1001': 'Beige / Bege', '1002': 'Sand Yellow / Amarelo areia',
    '1003': 'Signal Yellow / Amarelo sinal', '1004': 'Golden Yellow / Amarelo ouro', '1005': 'Honey Yellow / Amarelo mel',
    '1006': 'Maize Yellow / Amarelo milho', '1007': 'Lamp Black / Preto lamparina', '1011': 'Brown Beige / Bege marrom',
    '1012': 'Linen / Linho', '1013': 'Oyster Beige / Bege ostra', '1014': 'Ivory / Marfim', '1015': 'Light Ivory / Marfim claro',
    '1016': 'Sulfur Yellow / Amarelo enxofre', '1017': 'Saffron Yellow / Amarelo açafrão', '1018': 'Zinc Yellow / Amarelo zinco',
    '1019': 'Grey Beige / Bege acinzentado', '1020': 'Olive Yellow / Amarelo oliva', '1021': 'Rape Yellow / Amarelo colza',
    '1023': 'Traffic Yellow / Amarelo tráfego', '1024': 'Ochre Yellow / Amarelo ocre', '1027': 'Curry / Curry',
    '1028': 'Melon Yellow / Amarelo melão', '1032': 'Broom Yellow / Amarelo vassoura', '1033': 'Dahlia Yellow / Amarelo dália',
    '1034': 'Pastel Yellow / Amarelo pastel', '1035': 'Pearl Beige / Bege pérola', '1036': 'Pearl Gold / Ouro pérola',
    '1037': 'Sun Yellow / Amarelo sol',
    '2000': 'Yellow Orange / Amarelo laranja', '2001': 'Red Orange / Laranja vermelha', '2002': 'Vermilion / Vermelhão',
    '2003': 'Pastel Orange / Laranja pastel', '2004': 'Pure Orange / Laranja pura', '2008': 'Bright Red Orange / Laranja vermelha brilhante',
    '2009': 'Traffic Orange / Laranja tráfego', '2010': 'Signal Orange / Laranja sinal', '2011': 'Deep Orange / Laranja profunda',
    '2012': 'Salmon Orange / Laranja salmão', '2013': 'Pearl Orange / Laranja pérola',
    '3000': 'Flame Red / Vermelho chama', '3001': 'Signal Red / Vermelho sinal', '3002': 'Carmine Red / Vermelho carmim',
    '3003': 'Ruby Red / Vermelho rubi', '3004': 'Purple Red / Vermelho púrpura', '3005': 'Black Red / Vermelho preto',
    '3007': 'Black Red / Vermelho preto', '3009': 'Oxide Red / Vermelho óxido', '3011': 'Brown Red / Vermelho marrom',
    '3012': 'Beige Red / Vermelho bege', '3013': 'Tomato Red / Vermelho tomate', '3014': 'Antique Pink / Rosa antigo',
    '3015': 'Light Pink / Rosa claro', '3016': 'Dark Red / Vermelho escuro', '3017': 'Rose / Rosa', '3018': 'Strawberry Red / Vermelho morango',
    '3020': 'Traffic Red / Vermelho tráfego', '3022': 'Brown Red / Vermelho marrom', '3027': 'Raspberry Red / Vermelho framboesa',
    '3028': 'Pure Red / Vermelho puro', '3031': 'Orient Red / Vermelho oriente', '3032': 'Pearl Ruby Red / Vermelho rubi pérola',
    '3033': 'Pearl Dark Red / Vermelho escuro pérola',
    '4001': 'Red Lilac / Lilás vermelho', '4002': 'Red Violet / Violeta vermelho', '4003': 'Red Lilac / Lilás vermelho',
    '4004': 'Claret Violet / Violeta bordeaux', '4005': 'Blue Lilac / Lilás azul', '4006': 'Traffic Purple / Púrpura tráfego',
    '4007': 'Purple Black / Preto púrpura', '4008': 'Signal Violet / Violeta sinal', '4009': 'Pastel Violet / Violeta pastel',
    '4010': 'Telemagenta / Telemagenta', '4011': 'Pearl Violet / Violeta pérola', '4012': 'Pearl Black Violet / Violeta preto pérola',
    '5000': 'Violet Blue / Azul violeta', '5001': 'Green Blue / Azul verde', '5002': 'Ultramarine Blue / Azul ultramarinho',
    '5003': 'Sapphire Blue / Azul safira', '5004': 'Black Blue / Azul preto', '5005': 'Signal Blue / Azul sinal',
    '5007': 'Brillant Blue / Azul brilhante', '5008': 'Grey Blue / Azul acinzentado', '5009': 'Azure Blue / Azul céu',
    '5010': 'Gentian Blue / Azul genciana', '5011': 'Steel Blue / Azul aço', '5012': 'Light Blue / Azul claro',
    '5013': 'Cobalt Blue / Azul cobalto', '5014': 'Pigeon Blue / Azul pombo', '5015': 'Sky Blue / Azul céu',
    '5017': 'Traffic Blue / Azul tráfego', '5018': 'Turquoise Blue / Azul turquesa', '5019': 'Capri Blue / Azul capri',
    '5020': 'Ocean Blue / Azul oceano', '5021': 'Water Blue / Azul água', '5022': 'Night Blue / Azul noite',
    '5023': 'Distant Blue / Azul distante', '5024': 'Pastel Blue / Azul pastel',
    '5025': 'Pearl Gentian Blue / Azul genciana pérola', '5026': 'Pearl Night Blue / Azul noite pérola',
    '6000': 'Patina Green / Verde pátina', '6001': 'Emerald Green / Verde esmeralda', '6002': 'Leaf Green / Verde folha',
    '6003': 'Olive Green / Verde oliva', '6004': 'Blue Green / Verde azulado', '6005': 'Moss Green / Verde musgo',
    '6006': 'Grey Green / Verde acinzentado', '6007': 'Bottle Green / Verde garrafa', '6008': 'Brown Green / Verde marrom',
    '6009': 'Fir Green / Verde abeto', '6010': 'Grass Green / Verde grama', '6011': 'Reseda Green / Verde reseda',
    '6012': 'Black Green / Verde preto', '6013': 'Reed Green / Verde junco', '6014': 'Yellow Green / Verde amarelado',
    '6015': 'Black Green / Verde preto', '6016': 'Turquoise Green / Verde turquesa', '6017': 'May Green / Verde maio',
    '6018': 'Yellow Green / Verde amarelado', '6019': 'Pastel Green / Verde pastel', '6020': 'Chromium Green / Verde crômio',
    '6021': 'Pale Green / Verde pálido', '6022': 'Olive Drab / Verde oliva acinzentado', '6024': 'Traffic Green / Verde tráfego',
    '6025': 'Fern Green / Verde samambaia', '6026': 'Opal Green / Verde opala', '6027': 'Light Green / Verde claro',
    '6028': 'Pine Green / Verde pinheiro', '6029': 'Mint Green / Verde menta', '6032': 'Signal Green / Verde sinal',
    '6033': 'Mint Turquoise / Turquesa menta', '6034': 'Pastel Turquoise / Turquesa pastel', '6035': 'Pearl Green / Verde pérola',
    '6036': 'Pearl Opal Green / Verde opala pérola', '6037': 'Pure Green / Verde puro',
    '7000': 'Squirrel Grey / Cinza esquilo', '7001': 'Silver Grey / Cinza prata', '7002': 'Olive Grey / Cinza oliva',
    '7003': 'Moss Grey / Cinza musgo', '7004': 'Signal Grey / Cinza sinal', '7005': 'Mice Grey / Cinza rato',
    '7006': 'Beige Grey / Cinza bege', '7008': 'Khaki Grey / Cinza cáqui', '7009': 'Green Grey / Cinza verde',
    '7010': 'Tarpan Grey / Cinza tarpã', '7011': 'Iron Grey / Cinza ferro', '7012': 'Basalt Grey / Cinza basalto',
    '7013': 'Brown Grey / Cinza marrom', '7015': 'Slate Grey / Cinza ardósia', '7016': 'Anthracite Grey / Cinza antracite',
    '7021': 'Black Grey / Cinza preto', '7022': 'Umbra Grey / Cinza terra de sombra', '7023': 'Concrete Grey / Cinza concreto',
    '7024': 'Graphite Grey / Cinza grafite', '7026': 'Granite Grey / Cinza granito', '7030': 'Stone Grey / Cinza pedra',
    '7031': 'Blue Grey / Cinza azulado', '7032': 'Pebble Grey / Cinza cascalho', '7033': 'Cement Grey / Cinza cimento',
    '7034': 'Yellow Grey / Cinza amarelado', '7035': 'Light Grey / Cinza claro', '7036': 'Platinum Grey / Cinza platina',
    '7037': 'Dusty Grey / Cinza poeirento', '7038': 'Light Grey / Cinza claro', '7039': 'Quartz Grey / Cinza quartzo',
    '7040': 'Window Grey / Cinza vidro', '7042': 'Traffic Grey A / Cinza tráfego A', '7043': 'Traffic Grey B / Cinza tráfego B',
    '7044': 'Silk Grey / Cinza seda', '7045': 'Telegrey 1 / Telegrey 1', '7046': 'Telegrey 2 / Telegrey 2',
    '7047': 'Telegrey 4 / Telegrey 4', '7048': 'Pearl Mouse Grey / Cinza rato pérola',
    '8001': 'Ochre Brown / Marrom ocre', '8002': 'Signal Brown / Marrom sinal', '8003': 'Clay Brown / Marrom argila',
    '8004': 'Copper Brown / Marrom cobre', '8007': 'Fawn Brown / Marrom cervo', '8008': 'Wood Brown / Marrom madeira',
    '8011': 'Nutria Brown / Marrom nutria', '8012': 'Red Brown / Marrom vermelho', '8014': 'Sepia Brown / Marrom sépia',
    '8015': 'Chestnut Brown / Marrom castanho', '8016': 'Mahogany Brown / Marrom mogno', '8017': 'Chocolate Brown / Marrom chocolate',
    '8019': 'Grey Brown / Marrom acinzentado', '8022': 'Black Brown / Marrom preto', '8023': 'Orange Brown / Marrom laranja',
    '8024': 'Beige Brown / Marrom bege', '8025': 'Pale Brown / Marrom pálido', '8028': 'Terracotta / Terracota',
    '8029': 'Pearl Copper / Cobre pérola',
    '9001': 'Cream / Creme', '9002': 'Light Grey / Cinza claro', '9003': 'Signal White / Branco sinal',
    '9004': 'Signal Black / Preto sinal', '9005': 'Jet Black / Preto jato', '9006': 'White Aluminium / Alumínio branco',
    '9007': 'Grey Aluminium / Alumínio cinza', '9010': 'Pure White / Branco puro', '9011': 'Graphite Black / Preto grafite',
    '9016': 'Traffic White / Branco tráfego', '9017': 'Traffic Black / Preto tráfego', '9018': 'Papyrus White / Branco papiro',
    '9022': 'Pearl Light Grey / Cinza claro pérola', '9023': 'Pearl Dark Grey / Cinza escuro pérola'
  };

  var LINHAS = {
    tmsr: {
      nome: 'Esmalte Sintético', type: 'large',
      handleTpl: 'tmsr-{RAL}-tintas-esmaltes',
      rals: ['1001','1002','1003','1004','1005','1006','1007','1011','1012','1013','1014','1015','1016','1017','1018','1019','1020','1021','1023','1024','1027','1028','1032','1033','1034','1035','1036','1037','2000','2001','2002','2003','2004','2008','2009','2010','2011','2012','2013','3000','3001','3002','3003','3004','3005','3007','3009','3011','3012','3013','3014','3015','3016','3017','3018','3020','3022','3027','3028','3031','3032','3033','4001','4002','4003','4004','4005','4006','4007','4008','4009','4010','4011','4012','5000','5001','5002','5003','5004','5005','5007','5008','5009','5010','5011','5012','5013','5014','5015','5017','5018','5019','5020','5021','5022','5023','5024','5025','5026','6000','6001','6002','6003','6004','6005','6006','6007','6008','6009','6010','6011','6012','6013','6014','6015','6016','6017','6018','6019','6020','6021','6022','6024','6025','6026','6027','6028','6029','6032','6033','6034','6035','6036','6037','7000','7001','7002','7003','7004','7005','7006','7008','7009','7010','7011','7012','7013','7015','7016','7021','7022','7023','7024','7026','7030','7031','7032','7033','7034','7035','7036','7037','7038','7039','7040','7042','7043','7044','7045','7046','7047','7048','8001','8002','8003','8004','8007','8008','8011','8012','8014','8015','8016','8017','8019','8022','8023','8024','8025','8028','8029','9001','9002','9003','9004','9005','9006','9007','9010','9011','9016','9017','9018','9022','9023']
    },
    tmer: {
      nome: 'Epóxi Standard 2K', type: 'large',
      handleTpl: 'tmer-{RAL}-tinta-epoxi-bicomponente',
      rals: ['1001','1002','1003','1004','1005','1006','1007','1011','1012','1013','1014','1015','1016','1017','1018','1019','1020','1021','1023','1024','1027','1028','1032','1033','1034','1035','1036','1037','2000','2001','2002','2003','2004','2008','2009','2010','2011','2012','2013','3000','3001','3002','3003','3004','3005','3007','3009','3011','3012','3013','3014','3015','3016','3017','3018','3020','3022','3027','3028','3031','3032','3033','4001','4002','4003','4004','4005','4006','4007','4008','4009','4010','4011','4012','5000','5001','5002','5003','5004','5005','5007','5008','5009','5010','5011','5012','5013','5014','5015','5017','5018','5019','5020','5021','5022','5023','5024','5025','5026','6000','6001','6002','6003','6004','6005','6006','6007','6008','6009','6010','6011','6012','6013','6014','6015','6016','6017','6018','6019','6020','6021','6022','6024','6025','6026','6027','6028','6029','6032','6033','6034','6035','6036','6037','7000','7001','7002','7003','7004','7005','7006','7008','7009','7010','7011','7012','7013','7015','7016','7021','7022','7023','7024','7026','7030','7031','7032','7033','7034','7035','7036','7037','7038','7039','7040','7042','7043','7044','7045','7046','7047','7048','8001','8002','8003','8004','8007','8008','8011','8012','8014','8015','8016','8017','8019','8022','8023','8024','8025','8028','8029','9001','9002','9003','9006','9007','9010','9011','9016','9017','9018','9022','9023']
    },
    tmed: {
      nome: 'Epóxi Dupla Função', type: 'large',
      handleTpl: 'tmed-{RAL}-tinta-epoxi-metal-dupla-funcao',
      rals: ['1001','1002','1003','1004','1005','1006','1007','1011','1012','1013','1014','1015','1016','1017','1018','1019','1020','1021','1023','1024','1027','1028','1032','1033','1034','1035','1036','1037','2000','2001','2002','2003','2004','2008','2009','2010','2011','2012','2013','3000','3001','3002','3003','3004','3005','3007','3009','3011','3012','3013','3014','3015','3016','3017','3018','3020','3022','3027','3028','3031','3032','3033','4001','4002','4003','4004','4005','4006','4007','4008','4009','4010','4011','4012','5000','5001','5002','5003','5004','5005','5007','5008','5009','5010','5011','5012','5013','5014','5015','5017','5018','5019','5020','5021','5022','5023','5024','5025','5026','6000','6001','6002','6003','6004','6005','6006','6007','6008','6009','6010','6011','6012','6013','6014','6015','6016','6017','6018','6019','6020','6021','6022','6024','6025','6026','6027','6028','6029','6032','6033','6034','6035','6036','6037','7000','7001','7002','7003','7004','7005','7006','7008','7009','7010','7011','7012','7013','7015','7016','7021','7022','7023','7024','7026','7030','7031','7032','7033','7034','7035','7036','7037','7038','7039','7040','7042','7043','7044','7045','7046','7047','7048','8001','8002','8003','8004','8007','8008','8011','8012','8014','8015','8016','8017','8019','8022','8023','8024','8025','8028','8029','9001','9002','9003','9004','9005','9006','9007','9010','9011','9016','9017','9018','9022','9023']
    },
    tpur: {
      nome: 'PU Alifático', type: 'large',
      handleTpl: 'tpur-{RAL}-tintas-pu-bicomponente',
      rals: ['1001','1002','1003','1004','1005','1006','1007','1011','1012','1013','1014','1015','1016','1017','1018','1019','1020','1021','1023','1024','1027','1028','1032','1033','1034','1035','1036','1037','2000','2001','2002','2003','2004','2008','2009','2010','2011','2012','2013','3000','3001','3002','3003','3004','3005','3007','3009','3011','3012','3013','3014','3015','3016','3017','3018','3020','3022','3027','3028','3031','3032','3033','4001','4002','4003','4004','4005','4006','4007','4008','4009','4010','4011','4012','5000','5001','5002','5003','5004','5005','5007','5008','5009','5010','5011','5012','5013','5014','5015','5017','5018','5019','5020','5021','5022','5023','5024','5025','5026','6000','6001','6002','6003','6004','6005','6006','6007','6008','6009','6010','6011','6012','6013','6014','6015','6016','6017','6018','6019','6020','6021','6022','6024','6025','6026','6027','6028','6029','6032','6033','6034','6035','6036','6037','7000','7001','7002','7003','7004','7005','7006','7008','7009','7010','7011','7012','7013','7015','7016','7021','7022','7023','7024','7026','7030','7031','7032','7033','7034','7035','7036','7037','7038','7039','7040','7042','7043','7044','7045','7046','7047','7048','8001','8002','8003','8004','8007','8008','8011','8012','8014','8015','8016','8017','8019','8022','8023','8024','8025','8028','8029','9001','9002','9003','9004','9005','9006','9007','9010','9011','9016','9017','9018','9022','9023']
    },
    ecr: {
      nome: 'Eurocoat', type: 'small',
      handleTpl: 'ecr-{RAL}-epoxi-bicomponente',
      rals: ['1006','1021','2004','3009','3020','5005','5015','5021','6029','7011','7034','7035','7037','7038','7040','7042','7044','8014','9002','9003','9005']
    },
    exar: {
      nome: 'Exapiso', type: 'small',
      handleTpl: 'exar-{RAL}-epoxi-bicomponente',
      rals: ['1006','1021','2004','3009','3020','5005','5015','5021','6026','6029','6032','7011','7016','7034','7037','7038','7040','7042','7044','9002','9005']
    },
    tcpr: {
      nome: 'PU Piso', type: 'small',
      handleTpl: 'tcpr-{RAL}-tintas-pu-bicomponente',
      rals: ['1006','1021','2004','3009','3020','5005','5015','5021','6026','6029','6032','7011','7016','7033','7034','7035','7037','7038','7040','7042','7044']
    },
    prs: {
      nome: 'Primer Sintético', type: 'small',
      handleMap: {'7040':'prs-7040-primer-sinttico-cinza-ral-7040','8004':'prs-8004-primer-sinttico-vermelho-oxido-ral-8004','9003':'prs-9003-primer-sinttico-branco-ral-9003'},
      rals: ['7040','8004','9003']
    },
    tpcr: {
      nome: 'PU Acabamento', type: 'small',
      handleMap: {'8014':'tpcr-8014-tintas-pu-bicomponente','9002':'tpcr-9002-tintas-pu-bicomponente','9003':'tpcr-9003-tintas-pu-bicomponente','9005':'tpcr-9005-tintas-pu-bicomponente'},
      rals: ['8014','9002','9003','9005']
    },
    exa: {
      nome: 'Exaprimer Piso', type: 'small',
      handleMap: {'7016':'tmed-exa-7016-tinta-epoxi-metal-dupla-funcao','7033':'tmed-exa-7033-tinta-epoxi-metal-dupla-funcao','7038':'tmed-exa-7038-tinta-epoxi-metal-dupla-funcao','7040':'tmed-exa-7040-tinta-epoxi-metal-dupla-funcao','7044':'tmed-exa-7044-tinta-epoxi-metal-dupla-funcao','9003':'tmed-exa-9003-tinta-epoxi-metal-dupla-funcao'},
      rals: ['7016','7033','7038','7040','7044','9003']
    },
    'tis-sb': {
      nome: 'Industrial Semi-Brilho', type: 'small',
      handleMap: {'1013':'tis-1013-tinta-industrial-semi-brilho','7023':'tis-7023-tinta-industrial-semi-brilho','7034':'tis-7034-tinta-industrial-semi-brilho','7035':'tis-7035-tinta-industrial-semi-brilho','8004':'tis-8004-tinta-industrial-semi-brilho','8023':'tis-8023-tinta-industrial-semi-brilho','9010':'tis-9010-tinta-industrial-semi-brilho'},
      rals: ['1013','7023','7034','7035','8004','8023','9010']
    },
    'tis-sp': {
      nome: 'Silicato Premium', type: 'small',
      handleMap: {'1013':'tis-1013-tinta-silicato-premium','7033':'tis-7033-tinta-silicato-premium','7034':'tis-7034-tinta-silicato-premium','7035':'tis-7035-tinta-silicato-premium','8004':'tis-8004-tinta-silicato-premium','8023':'tis-8023-tinta-silicato-premium','9010':'tis-9010-tinta-silicato-premium'},
      rals: ['1013','7033','7034','7035','8004','8023','9010']
    },
    tat: {
      nome: 'Alta Temperatura', type: 'special',
      handleMap: {'200':'tat-200-tinta-alta-temperatura-at-200-graus-alumnio-ral','300':'tat-300-tinta-alta-temperatura-at-300-graus-alumnio-ral','450':'tat-450-tinta-alta-temperatura-at-450-graus-alumnio-ral','600':'tat-600-tinta-alta-temperatura-at-600-graus-alumnio-ral'},
      ralLabels: {'200':'Até 200°C','300':'Até 300°C','450':'Até 450°C','600':'Até 600°C'},
      title: 'Outras opções de temperatura', subtitle: 'Disponível em 4 faixas de temperatura.',
      rals: ['200','300','450','600']
    },
    ad: {
      nome: 'Demarcação Viária', type: 'special',
      handleMap: {'1':'ad-1-demarcacao-viaria','2':'ad-2-demarcacao-viaria','5':'ad-5-demarcacao-viaria','6':'ad-6-demarcacao-viaria','7':'ad-7-demarcacao-viaria'},
      ralLabels: {'1':'Preta NBR-11862','2':'Branca NBR-11862','5':'Azul NBR-11862','6':'Vermelha NBR-11862','7':'Amarela NBR-11862'},
      colorMap: {'1':'#1C1C1C','2':'#FFFFFF','5':'#004B87','6':'#CC0605','7':'#EDBE13'},
      title: 'Outras cores de Demarcação Viária', subtitle: 'Disponível em 5 cores conforme NBR-11862.',
      rals: ['1','2','5','6','7']
    },
    aer: {
      nome: 'Demarcação Aeroportuária', type: 'special',
      handleMap: {'100':'aer-100-demarcacao-aeroportuaria','200':'aer-200-demarcacao-aeroportuaria','500':'aer-500-demarcacao-aeroportuaria','600':'aer-600-demarcacao-aeroportuaria','700':'aer-700-demarcacao-aeroportuaria'},
      ralLabels: {'100':'Preta Infraero','200':'Branca Infraero','500':'Azul Infraero','600':'Vermelha Infraero','700':'Amarela Infraero'},
      colorMap: {'100':'#1C1C1C','200':'#FFFFFF','500':'#004B87','600':'#CC0605','700':'#EDBE13'},
      title: 'Outras cores de Demarcação Aeroportuária', subtitle: 'Disponível em 5 cores conforme NBR-8169.',
      rals: ['100','200','500','600','700']
    },
    tme: {
      nome: 'Eurolac', type: 'special',
      handleMap: {'499':'tme-499-epoxi-eurolack','501':'tme-501-epoxi-eurolack','727':'tme-727-epoxi-eurolack','756':'tme-756-epoxi-eurolack','758':'tme-758-epoxi-eurolack'},
      ralLabels: {'499':'Cinza','501':'Preto','727':'Branco','756':'Platina','758':'Branco Polar'},
      title: 'Outras opções', subtitle: 'Disponível em 5 variantes de Eurolac.',
      rals: ['499','501','727','756','758'],
      colorMap: {'499':'#808080','501':'#0A0A0A','727':'#FFFFFF','756':'#C0C0C0','758':'#F4F4F4'}
    }
  };

  /* ── helpers ── */
  var imageCache = {};

  function detectLine(handle) {
    var h = handle.toLowerCase();
    if (h.startsWith('tmed-exa-')) return 'exa';
    if (h.startsWith('tis-') && h.includes('semi-brilho')) return 'tis-sb';
    if (h.startsWith('tis-') && h.includes('silicato')) return 'tis-sp';
    var prefix = h.split('-')[0];
    return LINHAS[prefix] ? prefix : null;
  }

  function getCurrentRAL(handle, lineKey) {
    var line = LINHAS[lineKey];
    if (!line) return null;
    if (line.handleMap) {
      for (var ral in line.handleMap) { if (line.handleMap[ral] === handle) return ral; }
      return null;
    }
    if (lineKey === 'exa') { var p = handle.split('-'); return p.length >= 3 ? p[2] : null; }
    if (line.handleTpl) { var p = handle.split('-'); return p.length >= 2 ? p[1] : null; }
    return null;
  }

  function ralName(ral) { return RAL_NAMES[ral] || ''; }

  function isVeryLight(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!m) return false;
    return (0.299*parseInt(m[1],16) + 0.587*parseInt(m[2],16) + 0.114*parseInt(m[3],16)) > 220;
  }

  function buildHandle(ral, lineKey) {
    var line = LINHAS[lineKey]; if (!line) return null;
    if (line.handleMap && line.handleMap[ral]) return line.handleMap[ral];
    if (line.handleTpl) return line.handleTpl.replace('{RAL}', ral);
    return null;
  }

  function getHex(ral, lineKey) {
    var line = LINHAS[lineKey];
    if (line && line.colorMap && line.colorMap[ral]) return line.colorMap[ral];
    return RAL_HEX[ral] || '#CCCCCC';
  }

  /* ── IMAGE LOADING: eager fetch, real <img> element ── */
  function loadProductImage(card) {
    var handle = card.getAttribute('data-handle');
    if (!handle) return;

    /* already loaded or loading */
    if (card.getAttribute('data-img-loaded')) return;
    card.setAttribute('data-img-loaded', '1');

    if (imageCache[handle]) {
      insertImg(card, imageCache[handle]);
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.product && data.product.images && data.product.images.length > 1) {
          var src = data.product.images[1].src;
          var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          imageCache[handle] = url;
          insertImg(card, url);
        }
      })
      .catch(function() { /* keep solid color fallback */ });
  }

  function insertImg(card, url) {
    var swatch = card.querySelector('.el-cp__swatch');
    if (!swatch) return;
    /* avoid duplicates */
    if (swatch.querySelector('img')) return;
    var img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.className = 'el-cp__swatch-img';
    img.loading = 'lazy';
    img.onload = function() { img.style.opacity = '1'; };
    swatch.appendChild(img);
  }

  /* Load images for all visible cards in batches to avoid hammering API */
  function loadImagesForCards(root, batchSize) {
    var cards = root.querySelectorAll('.el-cp__card[data-handle]');
    var idx = 0;
    var size = batchSize || 6;

    function nextBatch() {
      var end = Math.min(idx + size, cards.length);
      for (var i = idx; i < end; i++) {
        loadProductImage(cards[i]);
      }
      idx = end;
      if (idx < cards.length) {
        setTimeout(nextBatch, 150);
      }
    }

    nextBatch();
  }

  /* ── Apply solid colors via JS (bypasses Shopify CSS override) ── */
  function applySwatchColors(root) {
    var swatches = root.querySelectorAll('.el-cp__swatch[data-hex]');
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      var hex = sw.getAttribute('data-hex');
      if (hex) {
        sw.style.setProperty('background-color', hex, 'important');
      }
    }
  }

  /* ── card rendering ── */
  function renderCard(ral, lineKey, currentRAL, isSpecial) {
    var line = LINHAS[lineKey];
    var hex = getHex(ral, lineKey);
    var handle = buildHandle(ral, lineKey);
    var isCurrent = ral === currentRAL;
    var lightBorder = isVeryLight(hex) ? ' el-cp__swatch--light' : '';
    var cls = 'el-cp__card' + (isCurrent ? ' el-cp__card--current' : '');
    var open = isCurrent ? '<div>' : '<a href="/products/' + handle + '">';
    var close = isCurrent ? '</div>' : '</a>';
    var badge = isCurrent ? '<span class="el-cp__badge">Atual</span>' : '';

    var info = '';
    if (isSpecial) {
      info = '<p class="el-cp__name">' + ((line.ralLabels && line.ralLabels[ral]) || ral) + '</p>';
    } else {
      var name = ralName(ral);
      info = '<p class="el-cp__code">RAL ' + ral + '</p>';
      if (name) info += '<p class="el-cp__name">' + name + '</p>';
    }

    return open +
      '<div class="' + cls + '" data-ral="' + ral + '" data-handle="' + (handle || '') + '">' +
        '<div class="el-cp__swatch' + lightBorder + '" data-hex="' + hex + '">' + badge + '</div>' +
        info +
      '</div>' +
    close;
  }

  /* ── type renderers ── */
  function renderLarge(container, line, lineKey, currentRAL) {
    var h = '<h3 class="el-cp__title">Procurando outra cor?</h3>';
    h += '<p class="el-cp__subtitle">Cartela RAL completa em ' + line.nome + '. Selecione uma categoria.</p>';

    h += '<div class="el-cp__chips">';
    RAL_CATS.forEach(function(cat) {
      var n = line.rals.filter(function(r) { return r.charAt(0) === cat.prefix; }).length;
      if (n === 0) return;
      h += '<button class="el-cp__chip" data-prefix="' + cat.prefix + '" style="--chip-color:' + cat.cor + '">';
      h += '<span class="el-cp__chip-dot"></span>' + cat.label + ' (' + n + ')';
      h += '</button>';
    });
    h += '<button class="el-cp__chip el-cp__chip--all" data-prefix="all">Todas (' + line.rals.length + ')</button>';
    h += '</div>';

    h += '<div class="el-cp__search-wrap" style="display:none">';
    h += '<input type="text" class="el-cp__search" placeholder="Buscar por RAL ou nome..." />';
    h += '</div>';

    h += '<div class="el-cp__grid el-cp__grid--large"></div>';

    container.innerHTML = h;

    var chips = container.querySelectorAll('.el-cp__chip');
    var grid = container.querySelector('.el-cp__grid');
    var searchWrap = container.querySelector('.el-cp__search-wrap');
    var searchInput = container.querySelector('.el-cp__search');

    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) { c.classList.remove('el-cp__chip--active'); });
        this.classList.add('el-cp__chip--active');

        var prefix = this.getAttribute('data-prefix');
        var isAll = prefix === 'all';

        searchWrap.style.display = isAll ? '' : 'none';
        if (searchInput) searchInput.value = '';

        var rals = isAll ? line.rals : line.rals.filter(function(r) { return r.charAt(0) === prefix; });
        var cards = '';
        rals.forEach(function(ral) { cards += renderCard(ral, lineKey, currentRAL, false); });
        grid.innerHTML = cards;

        if (isAll) { grid.classList.add('el-cp__grid--scroll'); } else { grid.classList.remove('el-cp__grid--scroll'); }

        /* apply colors via JS after DOM insertion */
        applySwatchColors(grid);
        /* eagerly load product images */
        loadImagesForCards(grid, 6);
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var term = this.value.toLowerCase().trim();
        grid.querySelectorAll('.el-cp__card').forEach(function(card) {
          var ral = card.getAttribute('data-ral') || '';
          var nameEl = card.querySelector('.el-cp__name');
          var nameText = nameEl ? nameEl.textContent.toLowerCase() : '';
          var match = !term || ('ral ' + ral).indexOf(term) > -1 || nameText.indexOf(term) > -1;
          card.parentElement.style.display = match ? '' : 'none';
        });
      });
    }
  }

  function renderSmall(container, line, lineKey, currentRAL) {
    var count = line.rals.length;
    var h = '<h3 class="el-cp__title">Procurando outra cor?</h3>';
    h += '<p class="el-cp__subtitle">' + count + ' cores disponíveis em ' + line.nome + '.</p>';
    h += '<div class="el-cp__grid el-cp__grid--small">';
    line.rals.forEach(function(ral) { h += renderCard(ral, lineKey, currentRAL, false); });
    h += '</div>';
    container.innerHTML = h;
    applySwatchColors(container);
    loadImagesForCards(container, 6);
  }

  function renderSpecial(container, line, lineKey, currentRAL) {
    var h = '<h3 class="el-cp__title">' + (line.title || 'Outras opções') + '</h3>';
    if (line.subtitle) h += '<p class="el-cp__subtitle">' + line.subtitle + '</p>';
    h += '<div class="el-cp__grid el-cp__grid--special">';
    line.rals.forEach(function(ral) { h += renderCard(ral, lineKey, currentRAL, true); });
    h += '</div>';
    container.innerHTML = h;
    applySwatchColors(container);
    loadImagesForCards(container, 6);
  }

  /* ── init ── */
  function init() {
    var container = document.getElementById('el-cor-picker');
    if (!container) return;
    var handle = container.getAttribute('data-handle');
    if (!handle) return;
    var lineKey = detectLine(handle);
    if (!lineKey) return;
    var line = LINHAS[lineKey];
    if (!line) return;
    var currentRAL = getCurrentRAL(handle, lineKey);

    if (line.type === 'large') renderLarge(container, line, lineKey, currentRAL);
    else if (line.type === 'small') renderSmall(container, line, lineKey, currentRAL);
    else if (line.type === 'special') renderSpecial(container, line, lineKey, currentRAL);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
